import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IFootballOrganizerDTO } from "../../../../../api-services/football/admin/manage-football-organizer-service";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageFootballOrganizerService } from "../../../../../commons";

export interface IFootballOrganizerAddOption {
  organizerData: IFootballOrganizerDTO;
}

interface IFootballOrganizerAdd {
  footballOrganizerAddStatus: StatusEnum;
}

const initialState: IFootballOrganizerAdd = {
  footballOrganizerAddStatus: StatusEnum.Idle,
};

export const footballOrganizerAdd = createAsyncThunk(
  "manage/footballOrganizerAdd",
  async (options: IFootballOrganizerAddOption, thunkAPI) => {
    try {
      const footballOrganizerAddResponse = await manageFootballOrganizerService.addOrganizer(options.organizerData);
      return footballOrganizerAddResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageFootballOrganizerAddSlice = createSlice({
  name: "footballOrganizerAdd",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(footballOrganizerAdd.pending, (state) => {
        state.footballOrganizerAddStatus = StatusEnum.Loading;
      })
      .addCase(footballOrganizerAdd.fulfilled, (state) => {
        state.footballOrganizerAddStatus = StatusEnum.Succeeded;
      })
      .addCase(footballOrganizerAdd.rejected, (state) => {
        state.footballOrganizerAddStatus = StatusEnum.Failed;
      });
  },
});

export default manageFootballOrganizerAddSlice.reducer;
